export default "__VITE_ASSET__Bq5VQ07I__"